let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7gE9h")).then(() => parcelRequire('X6lFY'));